

















import { Component, Prop, Mixins } from "vue-property-decorator";

// Components
import ProvisionField from "@/components/app/admin/catalogue/products/provisioning/provisionField.vue";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Types
import {
  IBasketProvisioningFieldsForm,
  IBlueprintField
} from "@/models/provisioning";

@Component({
  components: {
    ProvisionField
  }
})
export default class ProductProvisionFields extends Mixins(HasValidation) {
  @Prop({ required: true })
  public value!: IBasketProvisioningFieldsForm["provision_field_values"];

  @Prop({ required: true })
  public productFields!: IBlueprintField[];

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ required: true })
  public isLoading!: boolean;

  public get provisionFieldValues() {
    return this.value;
  }

  public set provisionFieldValues(value) {
    this.$emit("input", value);
  }
}
